import React, { useState } from "react";
import WardManagement from "./WardManagement";
import RoadManagement from "./RoadManagement";
import RateManagement from "./RateManagement";
import BuildingTaxRates from "./BuildingTaxRates";
import NameRegistration from "./NameRegistration";
import BuildingTypeForm from "./BuildingTypeForm";
import BuildingFactorForm from "./BuildingFactorForm";
import BuildingAgeRateForm from "./BuildingAgeRateForm";
import MilkatKarAakarni from "./MilkatKarAakarni";
import NamunaNo8Form from "./NamunaNo8Form";
import FerfarForm from "./FerfarForm";
import "./TaxCalculationDashboard.css";

const TaxCalculationDashboard = () => {
  const [activeTab, setActiveTab] = useState("ward");

  const tabs = [
    { id: "ward", label: "वॉर्ड व्यवस्थापन", icon: "📍" },
    { id: "road", label: "रोड / गल्ली व्यवस्थापन", icon: "🛣️" },
    { id: "rate", label: "दरांची माहिती", icon: "💰" },
    { id: "building", label: "इमारती दरे", icon: "🏗️" },
    { id: "nameregistration", label: "नाव नोंदणी", icon: "👤" },
    { id: "buildingtype", label: "इमारत मूल्य", icon: "🏢" },
    { id: "buildingfactor", label: "भारांक दर", icon: "⚖️" },
    { id: "buildingage", label: "वयोमान दर", icon: "📅" },
    { id: "milkat", label: "कर आकारणी", icon: "💳" },
    { id: "namunaNo8", label: "नमुना नं ८", icon: "📋" },
    { id: "ferfar", label: "फेरफार नमुना नं ८", icon: "🔄" },
  ];

  return (
    <div className="dashboard-container">
      {/* Header */}
      <div className="dashboard-header">
        <h1>🏛️ ग्रामपंचायत कर गणना प्रणाली</h1>
        <p>Tax Calculation Management System</p>
      </div>

      {/* Navigation Tabs */}
      <div className="dashboard-tabs">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`tab-button ${activeTab === tab.id ? "active" : ""}`}
            onClick={() => setActiveTab(tab.id)}
          >
            <span className="tab-icon">{tab.icon}</span>
            <span className="tab-label">{tab.label}</span>
          </button>
        ))}
      </div>

      {/* Content Area */}
      <div className="dashboard-content">
        {activeTab === "ward" && <WardManagement />}
        {activeTab === "road" && <RoadManagement />}
        {activeTab === "rate" && <RateManagement />}
        {activeTab === "building" && <BuildingTaxRates />}
        {activeTab === "nameregistration" && <NameRegistration />}
        {activeTab === "buildingtype" && <BuildingTypeForm />}
        {activeTab === "buildingfactor" && <BuildingFactorForm />}
        {activeTab === "buildingage" && <BuildingAgeRateForm />}
        {activeTab === "milkat" && <MilkatKarAakarni />}
        {activeTab === "namunaNo8" && <NamunaNo8Form />}
        {activeTab === "ferfar" && <FerfarForm />}
      </div>
    </div>
  );
};

export default TaxCalculationDashboard;
